import { defineMessages } from 'react-intl';

export const scope = 'app.components.Communication.HistoryPanel';

export const messages = defineMessages({
  // Shown on a send event while its rows are still draining the delivery queue,
  // in place of the final sent/failed tally (withheld until every row settles).
  sendingSummary: {
    id: `${scope}.sendingSummary`,
    defaultMessage: 'Sending — {delivered} of {total} delivered'
  }
});
